import Vue from "vue";
import Vuetify from "vuetify/lib";
import { AppI18n } from "./i18n";
import { getThemeOptions } from "@/common/theme/Themes";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export const AppVuetify = new Vuetify({
  theme: getThemeOptions(process.env.VUE_APP_CUSTOMER ? process.env.VUE_APP_CUSTOMER : ""),
  icons: {
    iconfont: "mdi",
  },
  lang: {
    t: (key: string, ...params: unknown[]): string => AppI18n.t(key, params) as string,
  },
});
